var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTapGesture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5667 10.6667C13.5667 9.95942 13.8476 9.28115 14.3477 8.78105C14.8478 8.28095 15.5261 8 16.2333 8C16.9406 8 17.6189 8.28095 18.119 8.78105C18.6191 9.28115 18.9 9.95942 18.9 10.6667V22.5867L22.1267 22.9333L35.3 28.7733C36.7133 29.4133 37.5667 30.8267 37.5667 32.3733V44C37.4867 46.1867 35.7533 47.92 33.5667 48H16.2333C15.22 48 14.26 47.6 13.5667 46.8533L0.5 35.6533L2.47333 33.6C2.98 33.04 3.7 32.7467 4.44667 32.7467H5.03333L13.5667 37.3333V10.6667ZM10.9 19.84V10.6667C10.9 9.25218 11.4619 7.89562 12.4621 6.89543C13.4623 5.89524 14.8188 5.33333 16.2333 5.33333C17.6478 5.33333 19.0044 5.89524 20.0046 6.89543C21.0048 7.89562 21.5667 9.25218 21.5667 10.6667V19.84C24.74 18 26.9 14.5867 26.9 10.6667C26.9 7.83769 25.7762 5.12458 23.7758 3.12419C21.7754 1.12381 19.0623 0 16.2333 0C13.4044 0 10.6912 1.12381 8.69086 3.12419C6.69047 5.12458 5.56667 7.83769 5.56667 10.6667C5.56667 14.5867 7.72667 18 10.9 19.84Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapGesture);
export default __webpack_public_path__ + "static/media/tap-gesture.a08143c26cb0b67280b1f659def31d10.svg";
export { ForwardRef as ReactComponent };